var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2377_203)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2377_203",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0H0.5V14H17.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2377_203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.01594 8.2007L2.64832 8.29242C2.32037 8.3744 2.02922 8.56364 1.82116 8.83007C1.61309 9.0965 1.50005 9.42483 1.5 9.76288V11.1856C1.50005 11.5236 1.61309 11.852 1.82116 12.1184C2.02922 12.3848 2.32037 12.5741 2.64832 12.656L3.96719 12.9865C4.03433 13.0032 4.1044 13.0044 4.17207 12.99C4.23973 12.9755 4.30321 12.9458 4.35767 12.9031C4.41212 12.8605 4.45612 12.8059 4.48631 12.7436C4.5165 12.6814 4.53208 12.6131 4.53188 12.5439V8.40308C4.53188 8.33394 4.51612 8.2657 4.48579 8.20356C4.45545 8.14142 4.41135 8.08702 4.35684 8.04449C4.30232 8.00196 4.23882 7.97241 4.17117 7.95811C4.10352 7.94381 4.0335 7.94512 3.96643 7.96194L3.01594 8.2007ZM3.01594 8.2007V7.82172C3.01594 4.05461 5.73098 1 9.07969 1C12.4284 1 15.1434 4.05461 15.1434 7.82172V8.2007M15.1434 8.2007L15.5111 8.29242C15.839 8.3744 16.1302 8.56364 16.3382 8.83007C16.5463 9.0965 16.6593 9.42483 16.6594 9.76288V11.1856C16.6593 11.5236 16.5463 11.852 16.3382 12.1184C16.1302 12.3848 15.839 12.5741 15.5111 12.656L14.1922 12.9865C14.125 13.0032 14.055 13.0044 13.9873 12.99C13.9196 12.9755 13.8562 12.9458 13.8017 12.9031C13.7473 12.8605 13.7033 12.8059 13.6731 12.7436C13.6429 12.6814 13.6273 12.6131 13.6275 12.5439V8.40308C13.6275 8.33402 13.6433 8.26587 13.6736 8.2038C13.7039 8.14173 13.7479 8.08738 13.8023 8.04486C13.8567 8.00234 13.9201 7.97278 13.9877 7.95841C14.0552 7.94405 14.1252 7.94525 14.1922 7.96194L15.1434 8.2007Z",
    stroke: "#2B2B67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2377_203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphoneIcon);
export default __webpack_public_path__ + "static/media/headphone-icon.05eb7e6e231287fca06e6d3850fcf7f0.svg";
export { ForwardRef as ReactComponent };